import React from "react"
import { AppFunctionComponent } from "../../../types"
import CrossIcon from "../../../images/icons/close.inline.svg"
import styled from "styled-components"

const Circle = styled.button`
  --circle-size: ${40 / 16}rem;
  --icon-size: 1rem;

  border: none;

  width: var(--circle-size);
  height: var(--circle-size);
  background: ${({ theme }) => theme.color.background};
  box-sizing: border-box;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  svg {
    fill: #000;
    width: var(--icon-size);
    height: var(--icon-size);
  }

  &:hover,
  &:active {
    background: #e5e5e5; // theme.color.commerceBorder
  }
  &:disabled {
    svg {
      fill: #e5e5e5;
    }
  }
`

interface Props {
  onClick: () => void
  disabled?: boolean
}

const CloseButton: AppFunctionComponent<Props> = (props) => {
  return (
    <Circle aria-label="Close" {...props}>
      <CrossIcon />
    </Circle>
  )
}

export default CloseButton
